import { useMemo } from 'react'
import { useLoadNoteTypesAllowZeroInstallments } from 'modules/setting/hooks/useLoadNoteTypesAllowZeroInstallments'

export function useNoteTypesAllowZeroInstallmentsSet() {
  const { data, isLoading } = useLoadNoteTypesAllowZeroInstallments({
    page: 1,
    limit: 999
  })

  const cdSet = useMemo(
    () => new Set((data?.data ?? []).map((b) => b.cdTipoNota)),
    [data?.data]
  )

  const allowsZeroInstallments = (cdTipoNota: string | undefined) =>
    !!cdTipoNota && cdSet.has(cdTipoNota)

  return { allowsZeroInstallments, isLoading }
}
